module.exports = __webpack_public_path__ + "img/hdfc-personal.3d7e8b94.jpg";